import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d2aab21e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./style/index.scss?vue&type=style&index=0&id=d2aab21e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aab21e",
  null
  
)

export default component.exports